import React, { useEffect, useState } from "react";
import "./Executives.css";

const ExecutiveOfficers = () => {
  const [flipped, setFlipped] = useState(null);

  useEffect(() => {
    var text = document.getElementById('text');
    if (text) {
      var newDom = '';
      var animationDelay = 6;

    for(let i = 0; i < text.innerText.length; i++) {
      newDom += '<span class="char1">' + (text.innerText[i] === ' ' ? '&nbsp;' : text.innerText[i]) + '</span>';
    }

    text.innerHTML = newDom;
    var length = text.children.length;

    for(let i = 0; i < length; i++) {
      text.children[i].style['animation-delay'] = animationDelay * i + 'ms';
    }
    }
  }, []);

  const executives = [
    {
      id: 1,
      name: "Kakra D. Nyarko",
      position: "Vice President",
      description:
        "Kakra Duffuor-Nyarko is the Vice president with a wealth of experience in leadership and management, driving organizational success..",
      image: "/images/Kakra.jpg",
    },
    {
      id: 2,
      name: "Magnus O. Agyemang",
      position: "Financial Secretary",
      description:
        "Magnus Owusu-Agyemang manages the financial operations and ensures proper accountability.",
      image: "/images/Magnus.jpg",
    },
    {
      id: 3,
      name: "Haris O. Yemoh",
      position: "Secretary",
      description:
        "Haris O. Yemoh oversees correspondence and maintains official records.",
      image: "/images/haris.png",
    },
    {
      id: 4,
      name: "Mark L. Henaku",
      position: "Executive Director",
      description:
        "Mark L. Henaku leads the execution of projects and strategic initiatives.",
      image: "/images/Mark.png",
    },
    
  ];

  const handleMouseEnter = (id) => {
    setFlipped(id);
  };

  const handleMouseLeave = () => {
    setFlipped(null);
  };

  return (
    
    <div className="executive-container">
      <section className="section">
      <div className="sectiontop-line"></div>
      <h2 className="sectiontitle">EXECUTIVE OFFICERS</h2>
      <div className="sectionbottom-line"></div>
      </section>
      <div className="executive-text">
            <p className="paragraph" id="text">Welcome to the Actuarial Society of Ghana! Here you can find information about our history,
            mission, and the contributions we make to the actuarial profession in Ghana and beyond. 
            Welcome to the Actuarial Society of Ghana! Here you can find information about our history,
                mission, and the contributions we make to the actuarial profession in Ghana and beyond.</p>
      </div>
        <div className="executive-grid">
        {/* President Card */}
        <div className="president-card">
            <div
            className={`executive-card ${flipped === 0 ? "flipped" : ""}`}
            onMouseEnter={() => handleMouseEnter(0)}
            onMouseLeave={handleMouseLeave}
            >
            <div className="card-front">
                <img
                src="/images/kofi.jpg"
                alt="Kofi Ntim"
                className="card-image"
                />
                <h3 className="executive-name">Kofi Ntim</h3>
                <p className="executive-position">President</p>
                <button className="card-plus">+</button>
            </div>
            <div className="card-back">
                <h3 className="executive-name">Kofi Ntim</h3>
                <p className="executive-description">
                Kofi Ntim is the President with extensive experience in organizational leadership.
                </p>
                <button className="read-more-btn">Read More</button>
            </div>
            </div>
        </div>

        {/* Other Cards */}
        <div className="other-cards">
            {executives.map((executive) => (
            <div
                key={executive.id}
                className={`executive-card ${
                flipped === executive.id ? "flipped" : ""
                }`}
                onMouseEnter={() => handleMouseEnter(executive.id)}
                onMouseLeave={handleMouseLeave}
            >
                <div className="card-front">
                <img
                    src={executive.image}
                    alt={executive.name}
                    className="card-image"
                />
                <h3 className="executive-name">{executive.name}</h3>
                <p className="executive-position">{executive.position}</p>
                <button className="card-plus">+</button>
                </div>
                <div className="card-back">
                <h3 className="executive-name">{executive.name}</h3>
                <p className="executive-description">{executive.description}</p>
                <button className="read-more-btn">Read More</button>
                </div>
            </div>
            ))}
        </div>
        </div>
    </div>
  );
};

export default ExecutiveOfficers;
